$mol_view_tree2_to_js_test_ex_array_boolean_foo $mol_object
	bar /boolean
		false
		true
